<template>
  <section>
    <component :is="selectedDialogAction" />
  </section>
</template>

<script>
import { eventBus } from "../eventbus";
import AddTreatmentDialogAction from "../AdminView/New/DialogActions/AddTreatmentDialogAction";
import AddClientDialogAction from "../AdminView/New/DialogActions/AddClientDialogAction";
import AddAppointmentDialogAction from "../AdminView/New/DialogActions/AddAppointmentDialogAction";
import UpdateAppointmentDialogAction from "../AdminView/New/DialogActions/UpdateAppointmentDialogAction";
import IsDoneDialogAction from "../AdminView/New/DialogActions/IsDoneDialogAction";
import HomeDialogAction from "./New/DialogActions/HomeDialogAction";

export default {
  name: "AdminDialogActions",
  components: {
    appAddTreatmentDialogAction: AddTreatmentDialogAction,
    appAddClientDialogAction: AddClientDialogAction,
    appAddAppointmentDialogAction: AddAppointmentDialogAction,
    appUpdateAppointmentDialogAction: UpdateAppointmentDialogAction,
    appIsDoneDialogAction: IsDoneDialogAction,
    appHomeDialogAction: HomeDialogAction,
  },
  data: function () {
    return {
      selectedDialogAction: "appHomeDialogAction",
    };
  },

  methods: {
    setDialogActions(option) {
      console.log("setDialogActions", option);
      switch (option) {
        case "NewClient":
          this.selectedDialogAction = "appAddClientDialogAction";
          break;
        case "NewAppointment":
          this.selectedDialogAction = "appAddAppointmentDialogAction";
          break;
        case "NewTreatment":
          this.selectedDialogAction = "appAddTreatmentDialogAction";
          break;
        case "Done":
          this.selectedDialogAction = "appIsDoneDialogAction";
          break;
        case "UpdateAppointment":
          this.selectedDialogAction = "appUpdateAppointmentDialogAction";
          break;
        case "Home":
          this.selectedDialogAction = "appHomeDialogAction";
          break;
        default:
          break;
      }
    },
  },
  created: function () {
    var self = this;

    eventBus.$on("select-admin-menu-option", function (option) {
      self.setDialogActions(option);
    });
    eventBus.$on("admin-tab-changed", function (tab) {
      if (tab == "home") self.setDialogActions("Home");
      console.log("event admin-tab-changed:", tab);
      if (tab == "add") self.setDialogActions("NewAppointment");
    });
    eventBus.$on(
      [
        "new-appointment-created",
        "appointment-updated",
        "new-treatment-created",
      ],
      function () {
        self.setDialogActions("Done");
      }
    );
  },
};
</script>

<style>
</style>